/**
 * Share
 */

import Config from "./share/Config";
import facebook from "./share/Facebook";
import twitter from "./share/Twitter";
import googleplus from "./share/Googleplus";
import line from "./share/Line";
import url from "./share/CopyUrl";

class Share {
  constructor(options) {
    if (options) {
      Object.assign(Config, options);
    }

    this.order = [facebook, twitter, line, googleplus, url];

    this.lang = {
      ko: {
        button: "공유",
        title: "글을 SNS에 공유해보세요."
      },
      en: {
        button: "Share",
        title: "Share your posts on SNS."
      },
      ja: {
        button: "共有",
        title: "文をSNSで共有しましょう。"
      },
      zh: {
        button: "分享",
        title: "讓我們與SNS分享句子。"
      }
    };
  }

  init() {
    this.setTemplate(Config.nodeId);
    this.addEvent(Config.nodeId);
    this.order.forEach(items => {
      items.init('.share__list');
    });
  }

  getLang() {
    let l10n = document.querySelector("html").getAttribute("lang");

    for (let prop in this.lang) {
      if (prop.indexOf(l10n) !== -1) {
        return this.lang[l10n];
      }
    }

    return this.lang["ko"];
  }

  setTemplate(id) {
    const lang = this.getLang();
    let _tmp = `<div class="share__wrap">
      <div class="share__title">${lang.title}</div>
      <div class="share__list"></div>
      <button class="btn__close"><i class="icon__close"></i></button>
    </div>
    <button class="btn__share--toggle">
      <i class="icon__share"></i>
      <span class="label">${lang.button}</span>
    </button>`;

    document.querySelector(id).insertAdjacentHTML("beforeend", _tmp);
  }

  addEvent() {
    document
      .querySelector(".btn__share--toggle")
      .addEventListener("click", this.toggleLayer);

    document
      .querySelector(".share__wrap .btn__close")
      .addEventListener("click", this.toggleLayer);
  }

  toggleLayer() {
    document.querySelector(".share__wrap").classList.toggle("is-active");
  }

  resetOptions(options) {
    Object.assign(Config, options);
    url.resetValue(Config.location);
  }
}

export default Share;
